import { useQuery } from '@tanstack/react-query';
import AuthService from '../services/authService';
import { isDeskAdmin } from '../utils/authHelpers';
import config, { isDemoHost } from '../config/api.config';
import { useBranch } from '../contexts/BranchContext';

export function useDeskAdmin() {
  const { selectedBranch } = useBranch();
  const brandId = selectedBranch?.brandId;
  const branchId = selectedBranch?.id;
  const demoMode = isDemoHost();

  const query = useQuery({
    queryKey: ['deskAdmin', brandId, branchId, demoMode],
    queryFn: async () => {
      if (demoMode) {
        const cached = AuthService.getUserInfo();
        return { isAdmin: true, userInfo: cached };
      }

      if (config.STAGE_NO_AUTH) {
        const cached = AuthService.getUserInfo();
        const mockAdmin =
          cached?.permissions?.includes('admin') ?? true;
        return { isAdmin: mockAdmin, userInfo: cached };
      }

      if (!AuthService.isAuthenticated()) {
        return { isAdmin: false, userInfo: null };
      }

      const userInfo = await AuthService.fetchUserInfo(brandId, branchId);
      return {
        isAdmin: isDeskAdmin(userInfo),
        userInfo,
      };
    },
    enabled: demoMode || config.STAGE_NO_AUTH || AuthService.isAuthenticated(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return {
    isAdmin: query.data?.isAdmin ?? false,
    isLoading: query.isLoading,
    userInfo: query.data?.userInfo ?? null,
    refetch: query.refetch,
  };
}
